<template>
  <div ref="container">
    <div>
      <div class="header">
          <img :src="topTitle" class="topImg">
          <div class="topTime">
              <img :src="topTime" class="topTimeImg">
              <span>{{time}}</span>
          </div>
          <!-- <audio ref="audio" :src="audioSrc" loop muted hidden></audio> -->
          <el-tooltip class="item" effect="light" content="退出登录" placement="bottom">
            <div class="out" @click="out">
              <i class="el-icon-switch-button" style="margin-right:5px"></i>
              <span>退出</span>
            </div>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="light" content="报警铃声 开启/关闭" placement="bottom">
            <div class="out" style="margin-right:0" v-on:click="getBell">
                <i class="el-icon-close-notification" v-show="!showBell"></i>
                <i class="el-icon-bell" v-show="showBell"></i>
            </div>
          </el-tooltip> -->
          <div class="titles">
              <span class="title">{{title}}</span>
          </div>
      </div>
      <!-- <div class="back" v-show="backShow">
        <div @click="back">
          <i class="el-icon-arrow-left"></i>
        </div>
      </div> -->
      <div>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {timefilters} from "@/common/times";
import {removeToken} from '@/utils/auth'
export default {
  name: 'Home',
  data(){
    return{
      time:timefilters(new Date()),
      topTitle:require('./WisdomCloud/img/topTitle.png'),
      topTime:require('./WisdomCloud/img/time.png'),
      lastPersonNum:0,
      conHeight:{
          height:''
      },
      backShow:false,
      showBell:true,
      title:'智慧云',
    }
  },
  mounted(){
      this.$nextTick(()=>{ // 页面渲染完成后的回调
          this.conHeight.height=window.innerHeight-150+'px'
      })
      this.init()
      this.getHight()
      window.addEventListener('resize', this.getHight);
  },
  watch: {
      //监听全局变量
      '$store.state.tableHeight' : function(){
          this.conHeight.height=window.innerHeight-150+'px'
      },
      '$store.state.title' : function(val){
          this.title=val
          document.title = val;
      },
      $route:{
          handler(newRouter){
            this.$store.commit('update', ['activeRouter', newRouter.path]);
            // if(newRouter.path=='/WisdomCloud/Index'){
            //   this.backShow=false
            // }else{
            //   this.backShow=true
            // }
          },
          immediate: true
      }
  },
  created(){
  },
  methods:{
    init(){
        var that=this
        setInterval(function () {
            that.time=timefilters(new Date());
        }, 1000);
        if(this.$store.state.activeRouter=='/'){
          this.$router.push({path:'/WisdomCloud/Index'})
        }else{
           this.$router.push({path:this.$store.state.activeRouter})
        }
    },
    getHight(){
      this.$store.commit('update', ['tableHeight',window.innerHeight]);
    },
    out(){
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        this.$router.push('/login')
      }).catch(() => {});
    },
    back(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss"  scoped>

      .header{
          position: relative;
          width: 100%;
          min-width: 1360px;
          height: 75px;
          z-index: 1000;
          .topImg{
              width: 100%;
              position: absolute;
              height: 111px;
          }
          .titles{
              width: 500px;
              margin: 0px auto;
              position: relative;
              color: #fff;
              text-align: center;
              line-height: 75px;
              font-weight: bold;
              font-size: 45px;
              text-shadow:5px 2px 6px #000;
          }
          .topTime{
              float: left;
              margin-left: 55px;
              margin-top: 5px;
              position: relative;
              color: #2FBFFA;
              background: rgba($color: #000000, $alpha: 0.4);
              padding: 1px 20px;
              font-size: 14px;
              height: 25px;
              border-radius: 20px;
              img{
                  height: 20px;
                  width: 20px;
                  transform: translate(0,4px);
              }
          }
          .out{
            float: right;
            margin-right: 55px;
            margin-top: 3px;
            font-size: 20px;
            position: relative;
            color: #2FBFFA;
            padding: 1px 20px;
            height: 25px;
            border-radius: 20px;
            cursor: pointer;
          }
      }

</style>
